import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.css";
import DownloadIcon from "../../../assets/images/icons/download.png";
import { getMyTickets } from "../../../redux/features/ticket/ticketServices";
import Capricom from "../../../assets/images/astro/1.png";
import Aquarius from "../../../assets/images/astro/2.png";
import Pisces from "../../../assets/images/astro/3.png";
import Aries from "../../../assets/images/astro/4.png";
import Taurus from "../../../assets/images/astro/5.png";
import Gemini from "../../../assets/images/astro/6.png";
import Cancer from "../../../assets/images/astro/7.png";
import Leo from "../../../assets/images/astro/8.png";
import Virgo from "../../../assets/images/astro/9.png";
import Libra from "../../../assets/images/astro/10.png";
import Scorpio from "../../../assets/images/astro/11.png";
import Sagittarius from "../../../assets/images/astro/12.png";
import DatePicker from "react-datepicker";
import { faCalendar, faRefresh, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination from "../../../components/Pagination";
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import JsBarcode from "jsbarcode";
import NoResultsFound from "../../../components/NoResultsFound";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useTranslation } from "react-i18next";

const tabs = [
  { id: "myTickets", label: "Ticket", status: "Pending" },
  { id: "winnings", label: "Winnings", status: "Win" },
  { id: "history", label: "History", status: null },
];

const astroImages = {
  1: Capricom,
  2: Aquarius,
  3: Pisces,
  4: Aries,
  5: Taurus,
  6: Gemini,
  7: Cancer,
  8: Leo,
  9: Virgo,
  10: Libra,
  11: Scorpio,
  12: Sagittarius,
};

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const TabButton = ({ id, label, activeTab, setActiveTab }) => {
  const { t, i18n } = useTranslation();
  return (
    <button
      className={`${styles.tabButton} ${activeTab === id ? styles.activeTab : ""
        }`}
      onClick={() => setActiveTab(id)}
    >
      {t(label)}
    </button>
  )
};

const MahajanaSampathaTicket = ({ masam }) => (
  <div className={styles.masamNumberRow}>
    <p className={styles.masamResultsLetter}>{masam.char}</p>
    {masam.recd.split("").map((char, index) => (
      <p key={index} className={styles.masamResultNumber}>
        {char}
      </p>
    ))}
  </div>
);

const MegaPowerTicket = ({ mepo }) => (
  <div className={styles.masamNumberRow}>
    <p className={styles.masamResultsLetter}>{mepo.char}</p>
    <p className={styles.masamResultSpNumber}>{mepo.sno.padStart(2, "0")}</p>
    <p className={styles.masamResultNumber}>{mepo.n1.padStart(2, "0")}</p>
    <p className={styles.masamResultNumber}>{mepo.n2.padStart(2, "0")}</p>
    <p className={styles.masamResultNumber}>{mepo.n3.padStart(2, "0")}</p>
    <p className={styles.masamResultNumber}>{mepo.n4.padStart(2, "0")}</p>
  </div>
);

const AdaSampathaTicket = ({ adsa }) => (
  <div className={styles.adsaNumberRow}>
    <p className={styles.masamResultsLetter}>{adsa.char}</p>
    <p className={`${styles.adsaResultNumberA} ${styles.masamResultNumber}`}>
      {adsa.arange.padStart(2, "0")}
    </p>
    <p className={`${styles.adsaResultNumberB} ${styles.masamResultNumber}`}>
      {adsa.brange.padStart(3, "0")}
    </p>
    <p className={`${styles.adsaResultNumberC} ${styles.masamResultNumber}`}>
      {adsa.crange.padStart(4, "0")}
    </p>
  </div>
);

const DhanaNidanayaTicket = ({ dhni }) => (
  <>
    <div className={styles.adsaNumberRow}>
      <p className={styles.dhniResultsLetter}>{dhni.char1}</p>
      <p className={styles.dhniResultNumber}>{dhni.n1.padStart(2, "0")}</p>
      <p className={styles.dhniResultNumber}>{dhni.n2.padStart(2, "0")}</p>
      <p className={styles.dhniResultNumber}>{dhni.n3.padStart(2, "0")}</p>
      <p className={styles.dhniResultNumber}>{dhni.n4.padStart(2, "0")}</p>
    </div>
    <div className={styles.adsaNumberRow}>
      <p className={styles.dhniResultsLetter}>{dhni.char2}</p>
      <p className={styles.dhniResultNumberSp}>
        {dhni.special.padStart(5, "0")}
      </p>
    </div>
  </>
);

const GovisethaTicket = ({ govi }) => (
  <div className={styles.masamNumberRow}>
    <p className={styles.masamResultsLetter}>{govi.char1}</p>
    <p className={styles.masamResultsLetter}>{govi.char2}</p>
    <p className={styles.masamResultNumber}>{govi.n1.padStart(2, "0")}</p>
    <p className={styles.masamResultNumber}>{govi.n2.padStart(2, "0")}</p>
    <p className={styles.masamResultNumber}>{govi.n3.padStart(2, "0")}</p>
    <p className={styles.masamResultNumber}>{govi.n4.padStart(2, "0")}</p>
  </div>
);

const HandahanaTicket = ({ hada }) => (
  <div className={styles.hadaCol}>
    <div className={styles.hadaLeftCol}>
      <img
        src={astroImages[hada.lagna]}
        alt={`${hada.lagna}`}
        className={styles.hadaAstro}
      />
    </div>
    <div className={styles.hadaRighttCol}>
      <div className={styles.adsaNumberRow}>
        <p className={styles.dhniResultNumber}>{hada.n1.padStart(2, "0")}</p>
        <p className={styles.dhniResultNumber}>{hada.n2.padStart(2, "0")}</p>
        <p className={styles.dhniResultNumber}>{hada.n3.padStart(2, "0")}</p>
        <p className={styles.dhniResultNumber}>{hada.n4.padStart(2, "0")}</p>
      </div>
      <div className={styles.hadaNumberRow}>
        <p className={styles.hadaSpecial}>{hada.special}</p>
        <p className={styles.hadaDaywaLetter}>{hada.dayn}</p>
      </div>
    </div>
  </div>
);

const JayaSampathaTicket = ({ jaya }) => (
  <div className={styles.jayaNumberRow}>
    <p className={styles.masamResultsLetter}>{jaya.char}</p>
    {jaya.recd.split("").map((char, index) => (
      <p key={index} className={styles.masamResultNumber}>
        {char}
      </p>
    ))}
  </div>
);

const Barcode = ({ value }) => {
  const svgRef = useRef();

  useEffect(() => {
    if (svgRef.current && value) {
      JsBarcode(svgRef.current, value, {
        format: "CODE128",
        lineColor: "#000",
        width: 2,
        height: 50,
        displayValue: true,
      });
    }
  }, [value]);

  return <svg ref={svgRef} />;
};

const MyTickets = () => {
  const { t, i18n } = useTranslation();
  const today = new Date();
  const formattedDate = formatDate(today);
  const [activeTab, setActiveTab] = useState("myTickets");
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(new Date());
  const [drawNumber, setDrawNumber] = useState("");
  const [isDate, setDate] = useState(false);
  const [skip, setSkip] = useState(1);
  const limit = 10;
  const {
    data: myTickets,
    isLoading,
    pageCount,
  } = useSelector((state) => state.ticket.myTickets || {});

  const handleSearch = (tab) => {
    setSkip(1);
    const selectedDate = startDate ? formatDate(startDate) : null;
    const params = {
      draw_no: drawNumber,
      draw_date: isDate && selectedDate,
      status: tab === "winnings" ? "Win" : null,
      limit: limit,
      skip: 1,
    };
    dispatch(getMyTickets(params));
  };

  const handleReset = (tab) => {
    // const selectedDate = startDate ? formatDate(startDate) : null;
    setStartDate(new Date());
    setDate(false);
    setSkip(1);
    setDrawNumber("");
    const params = {
      // draw_no: drawNumber,
      // draw_date: selectedDate,
      status: tab === "winnings" ? "Win" : null,
      limit: limit,
      skip: 1,
    };
    dispatch(getMyTickets(params));
  };

  useEffect(() => {
    const selectedTab = tabs.find((tab) => tab.id === activeTab);
    const selectedDate = startDate ? formatDate(startDate) : null;
    setSkip(1);
    const params = {
      draw_no: drawNumber,
      draw_date: isDate && selectedDate,
      ...(selectedTab.status !== null && { status: selectedTab.status }),
      limit: limit,
      skip: 1,
    };
    dispatch(getMyTickets(params));
  }, [dispatch, formattedDate, activeTab]);

  const handleDownload = async (ticket) => {
    // Ticket overlay
    const element = document.getElementById(`ticket-${ticket.id}`);
    if (!element) return;

    // Set the element to be visible for the download
    element.style.position = "absolute";
    element.style.top = "0";
    element.style.left = "0";
    element.style.opacity = "1";
    element.style.pointerEvents = "auto";
    element.style.zIndex = "-1";

    const canvas = await html2canvas(element, {
      useCORS: true,
      backgroundColor: "transparent",
      scale: 3,
    });
    const imgData = canvas.toDataURL("image/jpeg", 1.0);

    // Create a temporary link to trigger the download
    const link = document.createElement("a");
    link.href = imgData;
    link.download = `ticket-${ticket.id}.jpeg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Reset the element to be hidden after download
    element.style.position = "absolute";
    element.style.top = "-9999px";
    element.style.left = "-9999px";
    element.style.opacity = "0";
    element.style.pointerEvents = "none";
  };

  const handlePageChange = (pageNumber) => {
    setSkip(pageNumber);
    const selectedTab = tabs.find((tab) => tab.id === activeTab);
    const selectedDate = startDate ? formatDate(startDate) : null;
    const params = {
      draw_date: isDate && selectedDate,
      draw_no: drawNumber,
      ...(selectedTab.status !== null && { status: selectedTab.status }),
      limit: limit,
      skip: pageNumber,
    };
    dispatch(getMyTickets(params));
  };

  return (
    <div className={styles.myTicketsContainer}>
      <div className={`main-container`}>
        <div className={`container-content`}>
          <div className={styles.myTicketsSubContainer}>
            <div className={styles.homeHeader}>
              <h1 className={styles.title}>{t(`Ticket`)}</h1>
            </div>

            <div className={styles.tabs}>
              {tabs.map((tab) => (
                <TabButton
                  key={tab.id}
                  {...tab}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
              ))}
            </div>
            {
              <div className={styles.ticketList}>
                {(activeTab === "history" || activeTab === "winnings") && (
                  <div className={styles.resultsForm}>
                    <div className={styles.searchRow}>
                      <div>
                        <div className={styles.label}>{t(`Date`)}</div>
                        <DatePicker
                          showIcon
                          selected={startDate}
                          onChange={(date) => {setStartDate(date); setDate(true)}}
                          icon={faCalendar}
                          className={styles.dateSelector}
                        />
                        {/* <input
                          type="date"
                          value={startDate}
                          onChange={(date) => setStartDate(date)}
                          className={styles.drawInput}
                          placeholder="Draw Date"
                        /> */}
                      </div>
                      <div className={styles.mobileRow}>
                        <div>
                          <div className={styles.label}>{t(`Draw`)}</div>
                          <input
                            type="text"
                            value={drawNumber}
                            onChange={(e) => setDrawNumber(e.target.value)}
                            className={styles.drawInput}
                            placeholder="Draw Number"
                          />
                        </div>
                        <div>
                          <div className={styles.label}></div>
                          <button
                            type="button"
                            className={styles.searchBtn}
                            onClick={() => handleSearch(activeTab)}
                          >
                            {t(`Search`)}
                          </button>
                          <button type="button" className={styles.searchMobileBtn}
                            onClick={() => handleSearch(activeTab)} >
                            <FontAwesomeIcon icon={faSearch} />
                          </button>
                        </div>
                        <div>
                          <div className={styles.label}></div>
                          <button
                            type="button"
                            className={styles.resetBtn}
                            onClick={() => handleReset(activeTab)}
                          >
                            <FontAwesomeIcon icon={faRefresh} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {isLoading && (
                  <div className={styles.tabSkeletonWrapper}>
                    {[...Array(3)].map((_, idx) => (
                      <div key={idx} className={styles.ticketRowSkeleton}>
                        <Skeleton
                          height={120}
                          width="100%"
                          className={styles.ticketColumn}
                        />
                      </div>
                    ))}
                  </div>
                )}

                {!isLoading && myTickets?.length > 0
                  ? myTickets.map((ticket) => {
                    const drawNumber = ticket.lottery?.draw_no;
                    const drawDate = ticket.lottery?.draw_date;
                    const lotteryName =
                      ticket.lottery?.lottery_brand_day?.name;
                    const logoUrl =
                      ticket.lottery?.lottery_brand_day?.lottery_brand
                        ?.logo_url;

                    return (
                      ticket && (
                        <div key={ticket.id} className={styles.ticketCard}>
                          {/* Hidden printable version for download Govisetha */}
                          {ticket.lottery?.lottery_brand_day?.lottery_brand
                            ?.code === "GOVI" && (
                              <div
                                id={`ticket-${ticket.id}`}
                                className={styles.govisethaTicketWrapper}
                                style={{
                                  position: "absolute",
                                  top: "-9999px",
                                  left: "-9999px",
                                  opacity: 0,
                                  pointerEvents: "none",
                                }}
                              >
                                <img
                                  src={require("../../../assets/images/tickets/govisetha_ticket_template.jpg")}
                                  alt="Ticket"
                                  className={styles.govisethaTicketImage}
                                />
                                <div className={styles.govisethaNumberRow}>
                                  <p className={styles.govisethaResultNumber}>
                                    {ticket.govi?.char2}
                                  </p>
                                  <p className={styles.govisethaResultNumber}>
                                    {ticket.govi?.n1?.padStart(2, "0")}
                                  </p>
                                  <p className={styles.govisethaResultNumber}>
                                    {ticket.govi?.n2?.padStart(2, "0")}
                                  </p>
                                  <p className={styles.govisethaResultNumber}>
                                    {ticket.govi?.n3?.padStart(2, "0")}
                                  </p>
                                  <p className={styles.govisethaResultNumber}>
                                    {ticket.govi?.n4?.padStart(2, "0")}
                                  </p>
                                </div>
                                <div className={styles.govisethaDrawNo}>
                                  {ticket.lottery?.draw_no}
                                </div>
                                <div className={styles.govisethaDrawDate}>
                                  {ticket.lottery?.draw_date}
                                </div>
                                <div className={styles.govisethaTicketNumber}>
                                  {ticket.govi?.number}
                                </div>
                                <div className={styles.govisethaResultSpNumber}>
                                  {ticket.govi?.char1}
                                </div>
                                <div className={styles.govisethaBarcodeNumber}>
                                  <Barcode value={ticket.code} />
                                </div>
                                <div className={styles.govisethaQrCode}>
                                  <QRCodeCanvas
                                    value={ticket.code}
                                    size={85}
                                    level="H"
                                  />
                                </div>
                              </div>
                            )}

                          {/* Hidden printable version for download Ada Sampatha */}
                          {ticket.lottery?.lottery_brand_day?.lottery_brand
                            ?.code === "ADSA" && (
                              <div
                                id={`ticket-${ticket.id}`}
                                className={styles.adaSampathaTicketWrapper}
                                style={{
                                  position: "absolute",
                                  top: "-9999px",
                                  left: "-9999px",
                                  opacity: 0,
                                  pointerEvents: "none",
                                }}
                              >
                                <img
                                  src={require("../../../assets/images/tickets/adasampatha_ticket_template.jpg")}
                                  alt="Ticket"
                                  className={styles.adaSampathaTicketImage}
                                />
                                <div className={styles.adaSampathaNumberRow1}>
                                  <p
                                    className={
                                      styles.adaSampathaResultRow1Digit1
                                    }
                                  >
                                    {ticket.adsa?.arange?.padStart(2, "0")[0]}
                                  </p>
                                  <p
                                    className={
                                      styles.adaSampathaResultRow1Digit2
                                    }
                                  >
                                    {ticket.adsa?.arange?.padStart(2, "0")[1]}
                                  </p>
                                </div>
                                <div className={styles.adaSampathaNumberRow2}>
                                  <p
                                    className={
                                      styles.adaSampathaResultRow2Digit1
                                    }
                                  >
                                    {ticket.adsa?.brange?.padStart(2, "0")[0]}
                                  </p>
                                  <p
                                    className={
                                      styles.adaSampathaResultRow2Digit2
                                    }
                                  >
                                    {ticket.adsa?.brange?.padStart(2, "0")[1]}
                                  </p>
                                  <p
                                    className={
                                      styles.adaSampathaResultRow2Digit3
                                    }
                                  >
                                    {ticket.adsa?.brange?.padStart(2, "0")[2]}
                                  </p>
                                </div>
                                <div className={styles.adaSampathaNumberRow3}>
                                  <p
                                    className={
                                      styles.adaSampathaResultRow3Digit1
                                    }
                                  >
                                    {ticket.adsa?.crange?.padStart(2, "0")[0]}
                                  </p>
                                  <p
                                    className={
                                      styles.adaSampathaResultRow3Digit2
                                    }
                                  >
                                    {ticket.adsa?.crange?.padStart(2, "0")[1]}
                                  </p>
                                  <p
                                    className={
                                      styles.adaSampathaResultRow3Digit3
                                    }
                                  >
                                    {ticket.adsa?.crange?.padStart(2, "0")[2]}
                                  </p>
                                  <p
                                    className={
                                      styles.adaSampathaResultRow3Digit4
                                    }
                                  >
                                    {ticket.adsa?.crange?.padStart(2, "0")[3]}
                                  </p>
                                </div>
                                <div className={styles.adaSampathaNumberRow4}>
                                  <p className={styles.adaSampathaResultNumber}>
                                    {ticket.adsa?.char}
                                  </p>
                                </div>
                                <div className={styles.adaSampathaDrawNo}>
                                  {ticket.lottery?.draw_no}
                                </div>
                                <div className={styles.adaSampathaDrawDate}>
                                  {ticket.lottery?.draw_date}
                                </div>
                                <div className={styles.adaSampathaTicketNumber}>
                                  {ticket.adsa?.number}
                                </div>
                                <div
                                  className={styles.adaSampathaResultSpNumber}
                                >
                                  {ticket.adsa?.char1}
                                </div>
                                <div
                                  className={styles.adaSampathaBarcodeNumber}
                                >
                                  <Barcode value={ticket.code} />
                                </div>
                                <div className={styles.adaSampathaQrCode}>
                                  <QRCodeCanvas
                                    value={ticket.code}
                                    size={85}
                                    level="H"
                                  />
                                </div>
                              </div>
                            )}

                          {/* Hidden printable version for download Dhana Nidhanaya */}
                          {ticket.lottery?.lottery_brand_day?.lottery_brand
                            ?.code === "DHNI" && (
                              <div
                                id={`ticket-${ticket.id}`}
                                className={styles.dhanaNidhanayaTicketWrapper}
                                style={{
                                  position: "absolute",
                                  top: "-9999px",
                                  left: "-9999px",
                                  opacity: 0,
                                  pointerEvents: "none",
                                }}
                              >
                                <img
                                  src={require("../../../assets/images/tickets/dhananidhanaya_ticket_template.jpg")}
                                  alt="Ticket"
                                  className={styles.dhanaNidhanayaTicketImage}
                                />
                                <div
                                  className={styles.dhanaNidhanayaNumberRow1}
                                >
                                  <p
                                    className={
                                      styles.dhanaNidhanayaResultNumber
                                    }
                                  >
                                    {ticket.dhni?.char2}
                                  </p>
                                </div>
                                <div
                                  className={styles.dhanaNidhanayaNumberRow2}
                                >
                                  <p
                                    className={
                                      styles.dhanaNidhanayaResultNumber
                                    }
                                  >
                                    {ticket.dhni?.char1}
                                  </p>

                                  <p
                                    className={
                                      styles.dhanaNidhanayaResultNumber
                                    }
                                  >
                                    {ticket.dhni?.n1?.padStart(2, "0")}
                                  </p>
                                  <p
                                    className={
                                      styles.dhanaNidhanayaResultNumber
                                    }
                                  >
                                    {ticket.dhni?.n2?.padStart(2, "0")}
                                  </p>
                                  <p
                                    className={
                                      styles.dhanaNidhanayaResultNumber
                                    }
                                  >
                                    {ticket.dhni?.n3?.padStart(2, "0")}
                                  </p>
                                  <p
                                    className={
                                      styles.dhanaNidhanayaResultNumber
                                    }
                                  >
                                    {ticket.dhni?.n4?.padStart(2, "0")}
                                  </p>
                                </div>
                                <div className={styles.dhanaNidhanayaDrawNo}>
                                  {ticket.lottery?.draw_no}
                                </div>
                                <div className={styles.dhanaNidhanayaDrawDate}>
                                  {ticket.lottery?.draw_date}
                                </div>
                                <div
                                  className={
                                    styles.dhanaNidhanayaResultSpNumber
                                  }
                                >
                                  {ticket.dhni?.special}
                                </div>
                                <div
                                  className={styles.dhanaNidhanayaBarcodeNumber}
                                >
                                  <Barcode value={ticket.code} />
                                </div>
                                <div className={styles.dhanaNidhanayaQrCode}>
                                  <QRCodeCanvas
                                    value={ticket.code}
                                    size={85}
                                    level="H"
                                  />
                                </div>
                              </div>
                            )}

                          {/* Hidden printable version for download Jaya */}
                          {ticket.lottery?.lottery_brand_day?.lottery_brand
                            ?.code === "JAYA" && (
                              <div
                                id={`ticket-${ticket.id}`}
                                className={styles.jayaTicketWrapper}
                                style={{
                                  position: "absolute",
                                  top: "-9999px",
                                  left: "-9999px",
                                  opacity: 0,
                                  pointerEvents: "none",
                                }}
                              >
                                <img
                                  src={require("../../../assets/images/tickets/jaya_ticket_template.jpg")}
                                  alt="Ticket"
                                  className={styles.jayaTicketImage}
                                />

                                <div className={styles.jayaNumberRow1}>
                                  <p className={styles.jayaResultNumber}>
                                    {ticket.jaya?.char}
                                  </p>
                                </div>
                                <div className={styles.jayaNumberRow2}>
                                  <p className={styles.jayaResultNumber}>
                                    {ticket.jaya?.recd?.padStart(2, "0")}
                                  </p>
                                </div>
                                <div className={styles.jayaDrawNo}>
                                  {ticket.lottery?.draw_no}
                                </div>
                                <div className={styles.jayaDrawDate}>
                                  {ticket.lottery?.draw_date}
                                </div>
                                <div className={styles.jayaResultSpNumber}>
                                  {ticket.jaya?.special}
                                </div>
                                <div className={styles.jayaBarcodeNumber}>
                                  <Barcode value={ticket.code} />
                                </div>
                                <div className={styles.jayaQrCode}>
                                  <QRCodeCanvas
                                    value={ticket.code}
                                    size={85}
                                    level="H"
                                  />
                                </div>
                              </div>
                            )}

                          {/* Hidden printable version for download Hadahana */}
                          {ticket.lottery?.lottery_brand_day?.lottery_brand
                            ?.code === "HADA" && (
                              <div
                                id={`ticket-${ticket.id}`}
                                className={styles.hadahanaTicketWrapper}
                                style={{
                                  position: "absolute",
                                  top: "-9999px",
                                  left: "-9999px",
                                  opacity: 0,
                                  pointerEvents: "none",
                                }}
                              >
                                <img
                                  src={require("../../../assets/images/tickets/hadahana_ticket_template.jpg")}
                                  alt="Ticket"
                                  className={styles.hadahanaTicketImage}
                                />

                                <div className={styles.hadahanaNumberRow}>
                                  <p className={styles.hadahanaResultNumber1}>
                                    {ticket.hada?.n1?.padStart(2, "0")}
                                  </p>
                                  <p className={styles.hadahanaResultNumber2}>
                                    {ticket.hada?.n2?.padStart(2, "0")}
                                  </p>
                                  <p className={styles.hadahanaResultNumber3}>
                                    {ticket.hada?.n3?.padStart(2, "0")}
                                  </p>
                                  <p className={styles.hadahanaResultNumber4}>
                                    {ticket.hada?.n4?.padStart(2, "0")}
                                  </p>
                                  <p className={styles.hadahanaResultLagna}>
                                    <img
                                      src={astroImages[ticket.hada.lagna]}
                                      alt={`Astrological sign ${ticket.hada.lagna}`}
                                      className={styles.hadaAstro}
                                    />
                                  </p>
                                </div>

                                <div className={styles.hadahanaDrawNo}>
                                  {ticket.lottery?.draw_no}
                                </div>
                                <div className={styles.hadahanaDrawDate}>
                                  {ticket.lottery?.draw_date}
                                </div>
                                <div className={styles.hadahanaResultSpNumber}>
                                  {ticket.hada?.special}
                                </div>
                                <div
                                  className={styles.hadahanaResultDanaNumber}
                                >
                                  {ticket.hada?.dayn}
                                </div>
                                <div className={styles.hadahanaBarcodeNumber}>
                                  <Barcode value={ticket.code} />
                                </div>
                                <div className={styles.hadahanaQrCode}>
                                  <QRCodeCanvas
                                    value={ticket.code}
                                    size={85}
                                    level="H"
                                  />
                                </div>
                              </div>
                            )}

                          {/* Hidden printable version for download Mahajana Sampatha */}
                          {ticket.lottery?.lottery_brand_day?.lottery_brand
                            ?.code === "MASAM" && (
                              <div
                                id={`ticket-${ticket.id}`}
                                className={styles.mahajanaTicketWrapper}
                                style={{
                                  position: "absolute",
                                  top: "-9999px",
                                  left: "-9999px",
                                  opacity: 0,
                                  pointerEvents: "none",
                                }}
                              >
                                <img
                                  src={require("../../../assets/images/tickets/mahajana_ticket_template.jpg")}
                                  alt="Ticket"
                                  className={styles.mahajanaTicketImage}
                                />
                                <div className={styles.mahajanaNumberRow}>
                                  <p className={styles.mahajanaResultChar}>
                                    {ticket.masam?.char}
                                  </p>
                                </div>
                                <div className={styles.mahajanaNumberRow}>
                                  <p className={styles.mahajanaResultNumbers}>
                                    {ticket.masam?.recd?.padStart(2, "0")}
                                  </p>
                                </div>
                                <div className={styles.mahajanaDrawNo}>
                                  {ticket.lottery?.draw_no}
                                </div>
                                <div className={styles.mahajanaDrawDate}>
                                  {ticket.lottery?.draw_date}
                                </div>

                                <div className={styles.mahajanaBarcodeNumber}>
                                  <Barcode value={ticket.code} />
                                </div>
                                <div className={styles.mahajanaQrCode}>
                                  <QRCodeCanvas
                                    value={ticket.code}
                                    size={85}
                                    level="H"
                                  />
                                </div>
                              </div>
                            )}

                          {/* Hidden printable version for download Mega Power */}
                          {ticket.lottery?.lottery_brand_day?.lottery_brand
                            ?.code === "MEPO" && (
                              <div
                                id={`ticket-${ticket.id}`}
                                className={styles.govisethaTicketWrapper}
                                style={{
                                  position: "absolute",
                                  top: "-9999px",
                                  left: "-9999px",
                                  opacity: 0,
                                  pointerEvents: "none",
                                }}
                              >
                                <img
                                  src={require("../../../assets/images/tickets/megapower_ticket_template.jpg")}
                                  alt="Ticket"
                                  className={styles.megaPowerTicketImage}
                                />
                                <div className={styles.megaPowerNumberRow}>
                                  <p className={styles.megaPowerResultChar}>
                                    {ticket.mepo?.char}
                                  </p>
                                  <p className={styles.megaPowerResultNumber}>
                                    {ticket.mepo?.n1?.padStart(2, "0")}
                                  </p>
                                  <p className={styles.megaPowerResultNumber}>
                                    {ticket.mepo?.n2?.padStart(2, "0")}
                                  </p>
                                  <p className={styles.megaPowerResultNumber}>
                                    {ticket.mepo?.n3?.padStart(2, "0")}
                                  </p>
                                  <p className={styles.megaPowerResultNumber}>
                                    {ticket.mepo?.n4?.padStart(2, "0")}
                                  </p>
                                </div>
                                <div className={styles.megaPowerDrawNo}>
                                  {ticket.lottery?.draw_no}
                                </div>
                                <div className={styles.megaPowerDrawDate}>
                                  {ticket.lottery?.draw_date}
                                </div>

                                <div className={styles.megaPowerResultSpNumber}>
                                  {ticket.mepo?.sno?.padStart(2, "0")}
                                </div>
                                <div className={styles.megaPowerBarcodeNumber}>
                                  <Barcode value={ticket.code} />
                                </div>
                                <div className={styles.megaPowerQrCode}>
                                  <QRCodeCanvas
                                    value={ticket.code}
                                    size={85}
                                    level="H"
                                  />
                                </div>
                              </div>
                            )}

                          <img
                            src={logoUrl}
                            alt="Lottery Logo"
                            className={styles.logo}
                          />

                          <div className={styles.ticketDetails}>
                            <div className={styles.lotteryName}>
                              {lotteryName}
                            </div>

                            {ticket.lottery?.lottery_brand_day?.lottery_brand
                              ?.code === "MASAM" && (
                                <MahajanaSampathaTicket masam={ticket.masam} />
                              )}
                            {ticket.lottery?.lottery_brand_day?.lottery_brand
                              ?.code === "MEPO" && (
                                <MegaPowerTicket mepo={ticket.mepo} />
                              )}
                            {ticket.lottery?.lottery_brand_day?.lottery_brand
                              ?.code === "ADSA" && (
                                <AdaSampathaTicket adsa={ticket.adsa} />
                              )}
                            {ticket.lottery?.lottery_brand_day?.lottery_brand
                              ?.code === "DHNI" && (
                                <DhanaNidanayaTicket dhni={ticket.dhni} />
                              )}
                            {ticket.lottery?.lottery_brand_day?.lottery_brand
                              ?.code === "GOVI" && (
                                <GovisethaTicket govi={ticket.govi} />
                              )}
                            {ticket.lottery?.lottery_brand_day?.lottery_brand
                              ?.code === "HADA" && (
                                <HandahanaTicket hada={ticket.hada} />
                              )}
                            {ticket.lottery?.lottery_brand_day?.lottery_brand
                              ?.code === "JAYA" && (
                                <JayaSampathaTicket jaya={ticket.jaya} />
                              )}
                          </div>

                          {activeTab === "winnings" && (
                            <div className={styles.priceColumn}>
                              <div className={styles.winningPrice}>
                                Winning Price
                              </div>
                              <div className={styles.winningPriceValue}>
                                {ticket.winning_price || "-"}
                              </div>
                            </div>
                          )}

                          <div className={styles.drawColumn}>
                            <div className={styles.draw}>
                              {t(`Draw`)} : {drawNumber}
                            </div>
                            <div className={styles.dateValue}>
                              {t(`Date`)} : {drawDate}
                            </div>
                          </div>

                          <img
                            src={DownloadIcon}
                            alt="Download"
                            className={styles.downloadIcon}
                            onClick={() => handleDownload(ticket)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      )
                    );
                  })
                  : !isLoading && <NoResultsFound />}
              </div>
            }
            <div className={styles.searchCardFooter}>
              {pageCount > 0 && (
                <div className={styles.paginationContainer}>
                  <Pagination
                    currentPage={skip}
                    totalPages={pageCount}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyTickets;
